export const ssr = false;
export const prerender = false;

import { PUBLIC_FLURPLE_APP_URL } from '$env/static/public';
import { flowApi } from '$lib/api/flow.api';
import { deleteCookie, getCookie } from '$lib/helpers/session';

import type { User } from '$lib/interfaces/interfaces';
import type { HttpError } from '@sveltejs/kit';

export async function load() {
  if (!getCookie('token')) return;

  try {
    const userInfoResponse = await flowApi.investors.userInfo();
    const userInfo: User = await userInfoResponse.json();

    return { userInfo };
  } catch (error) {
    if ((error as HttpError).status === 401) {
      deleteCookie('token');
      window.location.href = `${PUBLIC_FLURPLE_APP_URL}/login?redirectUrl=${window.location.href}`;
    } else if ((error as HttpError).status === 403 && getCookie('impersonation_token')) {
      // Stale impersonation session (expired, revoked or superseded) — drop it
      // and continue with the user's own session instead of logging them out
      deleteCookie('impersonation_token');
      deleteCookie('impersonation_original_url');
      window.location.reload();
    } else {
      throw 'An unexpected error occurred when trying to get user information';
    }
  }
}
